export const Footer = () => (
  <footer className="bg-navy text-white" data-testid="site-footer">
    <div className="tricolour-bar" />
    <div className="gp-container py-10 space-y-2">
      <p className="font-hi text-lg font-bold">🏆 ग्राम पाठशाला मानपुर</p>
      <p className="text-white/80">Grampathshala — Free Library Movement Across India</p>
      <p className="font-hi text-amber-300">एक संकल्प, एक संदेश — भारत बने पुस्तकालयों का देश!</p>
      <p className="text-xs text-white/50 pt-4">Organizer: Grampathshala Manpur · Manpur Stadium, Manpur, Haryana</p>
      <a href="/registrations" className="inline-flex items-center min-h-[44px] mt-2 px-4 rounded-full border border-orange-300/50 text-sm text-orange-300" data-testid="footer-data-link">पंजीकृत खिलाड़ी सूची / Excel डाउनलोड</a>
    </div>
  </footer>
);
